export enum ETemplateExamType {
  PreExamination = 'pre-examination',
  General = 'general',
  Part = 'part'
}
